"use client";

import { useState } from "react"

import Header from "@/components/ui/Header/Header"
import Search from "@/components/ui/Search"
import NewsNewestCard from "@/components/news/NewsNewestCard"
import NewsListCard from "@/components/news/NewsListCard"
import { Pagination } from "@/components/common"
import BookletAboutUs from "@/components/booklets/BookletAboutUs"
import NewsFilterCard from "./NewsFilterCard"
import NewsDetailsCard from "@/components/news/NewsDetailsCard"
import { NewsCategory, NewsDetails, NewsList, NewsYearMonth } from "@/@types"

type Props = {
  NewsList?: NewsList
  NewsCategory: NewsCategory[]
  NewsYearMonth: NewsYearMonth[]
  NewestNews?: NewsDetails | null
  NewsDetails?: NewsDetails
  showNewestCard?: boolean
  categorySlug?: string
}

export default function NewsContainer({
  NewsList,
  NewsCategory,
  NewsYearMonth,
  NewestNews,
  NewsDetails,
  showNewestCard = true,
  categorySlug,
}: Props) {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)


  const toggleFilterModal = () => {
    setIsFilterModalOpen((prev) => !prev)
  }

  return (
    <div className="bg-silver">
      <Header
        variant="dark"
        description="Descubre información sobre maquinaria pesada de marcas líderes. Aprende a mantener tu equipo en óptimas condiciones y maximizar su uso."
      />
      <div className="container pb-32">
        {
        showNewestCard && NewestNews 
        ? <NewsNewestCard NewestNews={NewestNews} /> : null
        }
        <div className="grid lg:grid-cols-[25%_90%] mt-8">
          <div className="grid grid-cols-1 auto-rows-min gap-4">
            <Search
              onOpenFilters={toggleFilterModal}
              baseSearchPath="/noticias"
            />
            <NewsFilterCard
              isMenuOpen={isFilterModalOpen}
              toggleMenu={toggleFilterModal}
              categories={NewsCategory}
              yearMonths={NewsYearMonth}
              selectedCategory={categorySlug}
            />
            <div className="hidden lg:block">
              <BookletAboutUs />
            </div>
          </div>
          <div className="w-full [@media(min-width:0px)_and_(max-width:325px)]:w-72 [@media(min-width:326px)_and_(max-width:375px)]:w-[350px] 
          [@media(min-width:376px)_and_(max-width:410px)]:w-[365px] [@media(min-width:410px)_and_(max-width:427px)]:w-96 
          [@media(min-width:428px)_and_(max-width:480px)]:w-[395px]
          [@media(min-width:768px)_and_(max-width:992px)]:w-[700px]
           lg:w-[84%] lg:pl-4 lg:pt-0">
            {NewsDetails ? (
              <NewsDetailsCard newsDetails={NewsDetails} />
            ) : (
              <>
                <h2 className="sr-only">Listado de noticias</h2>
                <NewsListCard newsList={NewsList} categorySlug={categorySlug} />
                {NewsList && NewsList.pagination.lastPage > 1 && (
                  <Pagination
                    result="Noticias"
                    currentPage={NewsList?.pagination.currentPage}
                    lastPage={NewsList?.pagination.lastPage}
                    totalResults={NewsList?.pagination.total}
                    perPage={NewsList?.pagination.perPage}
                  />
                )}
              </>
            )}
          </div>
        </div>
        <div className="block lg:hidden mt-8">
          <BookletAboutUs />
        </div>
      </div>
    </div>
  );
}
